export default {
  'pages.applicationCatalog.openDirectory': '應用管理',
  'pages.applicationCatalog.title': '業務應用',
  'pages.applicationCatalog.selectAppHint': '從左側選擇應用檢視詳情',
  'pages.applicationCatalog.backToCenter': '返回應用',
  'pages.applicationCatalog.create': '新增應用',
  'pages.applicationCatalog.edit': '編輯應用',
  'pages.applicationCatalog.refresh': '重新整理',
  'pages.applicationCatalog.details': '詳情',
  'pages.applicationCatalog.resources': '資源管理',
  'pages.applicationCatalog.delete': '刪除應用',
  'pages.applicationCatalog.more': '更多',
  'pages.applicationCatalog.moreForApp': '更多操作：{name}',
  'pages.applicationCatalog.deleteTitle': '確定從全平台刪除應用「{name}」？',
  'pages.applicationCatalog.deleteDescription':
    '將刪除共用 IAM 應用及本地擴充資訊，影響所有使用此應用的企業。此操作無法復原，也不是取消目前企業的開通。',
  'pages.applicationCatalog.deleteConfirm': '從全平台刪除',
  'pages.applicationCatalog.cancel': '取消',
};
